/**
 * PhotoThumb — Phase 4e.B (Feb 2026)
 *
 * Zeigt ein WMS-Foto via authentifiziertem Fetch (kein direkter <img src>,
 * da Object-Storage Auth-Header benötigt). Cleanup von blob: URL bei unmount.
 */
import { useEffect, useState } from "react";
import api from "../../lib/api";

export default function PhotoThumb({ path, token, alt = "" }) {
    const [src, setSrc] = useState(null);
    const [err, setErr] = useState(false);

    useEffect(() => {
        let blobUrl = null;
        let cancelled = false;
        (async () => {
            try {
                const r = await api.get(`/wms/photos/${path}`, { responseType: "blob" });
                if (cancelled) return;
                blobUrl = URL.createObjectURL(r.data);
                setSrc(blobUrl);
            } catch (_e) {
                if (!cancelled) setErr(true);
            }
        })();
        return () => {
            cancelled = true;
            if (blobUrl) URL.revokeObjectURL(blobUrl);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path]);

    if (err) {
        return <div className="w-full h-full bg-red-50 flex items-center justify-center text-[10px] text-red-500">Fehler</div>;
    }
    if (!src) {
        return <div className="w-full h-full bg-gray-100 animate-pulse" />;
    }
    return <img src={src} alt={alt} className="w-full h-full object-cover" />;
}
